<component v-bind:is="getType"
    v-bind:propsData="getPropsData"
    v-bind:code="code"
    v-bind:selectId="selectId"
    v-bind:optionType="optionType"
    v-bind:showName="true">
</component>